"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useProfileCookieHandler = void 0;
const react_1 = require("react");
const react_cookie_1 = require("react-cookie");
const cookieOpts = {
    path: '/',
    maxAge: 60 * 60 * 24 * 90,
};
function removeNils(obj) {
    return Object.fromEntries(Object.entries(obj).filter(([_, value]) => value !== null && value !== undefined));
}
function useProfileCookieHandler(cookieName) {
    const [_, setCookie, removeCookie] = (0, react_cookie_1.useCookies)([cookieName]);
    const profile = (0, react_1.useRef)({});
    return (0, react_1.useMemo)(() => ({
        updateProfile(update) {
            profile.current = removeNils(update === null ? {} : { ...profile.current, ...update });
            const json = JSON.stringify(profile.current);
            if (Object.keys(profile.current).length > 0) {
                setCookie(cookieName, json, cookieOpts);
            }
            else {
                removeCookie(cookieName, cookieOpts);
            }
        },
    }), [cookieName, removeCookie, setCookie]);
}
exports.useProfileCookieHandler = useProfileCookieHandler;
//# sourceMappingURL=index.js.map